<template>
  <div id="app" class="app-wrap" :class="{ 'no-tabbar': !showTabbar }">
    <keep-alive :include="keepAliveNames">
      <router-view :key="$route.fullPath" />
    </keep-alive>
    <!-- 底部导航栏：仅在首页和我的页面显示 -->
    <van-tabbar 
      v-show="showTabbar" 
      v-model="activeTab" 
      route 
      fixed 
      :placeholder="showTabbar"
      safe-area-inset-bottom
    >
      <van-tabbar-item to="/" icon="home-o" name="home">首页</van-tabbar-item>
      <van-tabbar-item to="/mine" icon="user-o" name="mine">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      activeTab: 'home',
      keepAliveNames: ['Home']
    }
  },
  computed: {
    showTabbar() {
      const tabbarRoutes = ['/', '/mine']
      return tabbarRoutes.includes(this.$route.path)
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        // 使用 nextTick 确保 DOM 更新完成
        this.$nextTick(() => {
          if (route.path === '/mine') {
            this.activeTab = 'mine'
          } else if (route.path === '/') {
            this.activeTab = 'home'
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import './styles/variables.css';

.app-wrap {
  min-height: 100%;
  padding-bottom: var(--tabbar-height);
  transition: padding var(--transition-normal);
  
  &.no-tabbar {
    padding-bottom: 0;
  }
}
</style>
